import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Employee } from "entitites/employees/model/employee";
import { useGetTeamLeadQuery } from "entitites/teams/api/teamsApi";

export const ProfBodyView = ({ employee }: { employee: Employee }) => {
  const { data: teamLeads } = useGetTeamLeadQuery(employee.id);
  return (
    <Box width="100%" display="flex" gap={0.25} flexDirection="column">
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Позиция
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.profInfo.position.name}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Компания
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.profInfo.company}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Направление
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.profInfo.position.direction}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Отдел
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.profInfo.position.department}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Тимлидер
        <Typography sx={{ ml: "auto", width: 300 }}>
          {teamLeads?.map((i) => i.teamLead.fio).join(", ")}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Проект
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.profInfo.project}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        График
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.profInfo.schedule}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Часы работы
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.profInfo.workTime}
        </Typography>
      </Box>
      {employee.profInfo.additionalFields.map((field) => (
        <Box key={field.id} display="flex" alignItems="center" width="100%">
          <Typography minWidth={255} maxWidth={255} noWrap fontWeight={600}>
            {field.label}
          </Typography>
          <Typography sx={{ ml: "auto", width: 300 }}>{field.value}</Typography>
        </Box>
      ))}
    </Box>
  );
};
